"use client";

import React, { ReactNode } from "react";
import { useMultiSelectStore } from "modules/common/stores/useMultiSelectStore";
import { cn } from "utils/utils";

interface SelectionVisibilityWrapperProps {
  children: ReactNode;
}

export function SelectionVisibilityWrapper({
  children,
}: SelectionVisibilityWrapperProps) {
  const isAnySelected = useMultiSelectStore(
    (s) => s.selectAllActive || s.selectedIds.size > 0
  );
  return (
    <div
      className={cn(
        "flex items-center justify-center",
        "transition-opacity duration-200 ease-in-out",
        "pointer-events-none opacity-0",
        "group-hover:pointer-events-auto group-hover:opacity-100",
        isAnySelected && "pointer-events-auto opacity-100"
      )}
    >
      {children}
    </div>
  );
}
